import { z } from 'zod';
import { array } from 'fp-ts';
import { WithRateGroupId, WithServiceId } from '@mews-commander/types';
import { PaymentAndCancellationPolicyUpdateParameters } from '@mews-commander/data-access';
import { PaymentPolicyFieldName, SettlementConfigurationsFieldName } from '../components/forms/types';

export const paymentPolicySchema = z.object({
    [PaymentPolicyFieldName.SettlementRules]: z.array(z.string()).min(1),
    [PaymentPolicyFieldName.CancellationFees]: z.array(z.string()).nullish(),
});

const requirePaymentCardDuringOnlineCheckInSchema = z.object({
    [SettlementConfigurationsFieldName.RequirePaymentCardDuringOnlineCheckIn]: z.boolean().nullish(),
});

export const editPaymentPolicySchema = paymentPolicySchema.merge(requirePaymentCardDuringOnlineCheckInSchema);

export type EditPaymentPolicyFormValues = z.infer<typeof editPaymentPolicySchema>;

export const toDefaultPaymentPolicyUpdateParameters =
    ({ rateGroupId, serviceId }: WithServiceId & WithRateGroupId) =>
    (values: EditPaymentPolicyFormValues): PaymentAndCancellationPolicyUpdateParameters => ({
        rateGroupId,
        serviceId,
        paymentPolicyIds: values.settlementRules,
        cancellationPolicyIds: array.isEmpty(values.cancellationFees ?? []) ? null : values.cancellationFees,
        requirePaymentCardDuringOnlineCheckIn: values.requirePaymentCardDuringOnlineCheckIn ?? undefined,
    });
